export default "__VITE_ASSET__ce8726da__"